import { render, staticRenderFns } from "./TSelectCourseModal.vue?vue&type=template&id=510900ff&scoped=true"
import script from "./TSelectCourseModal.vue?vue&type=script&lang=js"
export * from "./TSelectCourseModal.vue?vue&type=script&lang=js"
import style0 from "./TSelectCourseModal.vue?vue&type=style&index=0&id=510900ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510900ff",
  null
  
)

export default component.exports